var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 10a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0ZM10 .25C4.615.25.25 4.615.25 10s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S15.385.25 10 .25Zm3.53 8.28a.75.75 0 0 0-1.06-1.06l-3.756 3.755-1.184-1.184a.75.75 0 1 0-1.06 1.06l1.714 1.715a.75.75 0 0 0 1.06 0L13.53 8.53Z",
    fill: "#ACC806"
  })));
};
export default SvgSuccess;